import {CountrySelector} from '@/components/JourneyEditor/components/CountrySelector'
import {useApplications} from '@/hooks/useApplications'
import {useCountries} from '@/hooks/useCountries'
import MessageTemplatesList from '@/pages/MessageTemplatesList'
import {ApplicationSelector} from '@/shared-components/ApplicationSelector/ApplicationSelector'
import {useAppDispatch, useAppSelector} from '@/store'
import {selectApplication, selectShellActive, setApplication} from '@/store/slices/commonSlice'
import {JourneyStatus} from '@/types/JourneyStatus'
import {setJourneyMeta} from '@ReduxActions'
import {useIntl} from 'react-intl'
import NoCountriesPage from './NoCountriesPage'

export default function MessageTemplates(): React.JSX.Element {
  const {formatMessage} = useIntl()
  const {countries, country} = useCountries()
  const dispatch = useAppDispatch()
  const shellActive = useAppSelector(selectShellActive)
  const application = useAppSelector(selectApplication)
  const {applications: availableApplications} = useApplications()
  const applications = availableApplications.map(item => item.code)

  const onCountryDidChange = (value: string) => {
    dispatch(setJourneyMeta({country: value}))
  }

  const onApplicationDidChange = (value: string) => {
    dispatch(setApplication(value))
  }
  return (
    <div className="grid gap-4" data-testid="message-templates-container">
      <div className="flex items-center justify-end">
        {/* <p className="text-3xl font-bold text-text-primary">
          {formatMessage(
            {id: 'MESSAGE_TEMPLATE_LIST.WELCOME_MESSAGE'},
            {
              userName: 'User',
            }
          )}
        </p> */}
        {!shellActive && (
          <div className="right-0 flex flex-row items-center gap-2 text-xs font-normal" data-tour-id="market-selector">
            <p className="text-nowrap">{formatMessage({id: 'GENERAL.SELECT_APPLICATION'})}</p>
            <ApplicationSelector
              id="main-application"
              applications={applications}
              value={application}
              onValueChanged={onApplicationDidChange}
            />
            <p className="ml-4 text-nowrap">{formatMessage({id: 'GENERAL.SELECT_MARKET'})}</p>
            <CountrySelector
              id="main-country"
              status={JourneyStatus.draft}
              countries={countries}
              value={country}
              onValueChanged={onCountryDidChange}
              disabled={!country}
            />
          </div>
        )}
      </div>
      {country ? (
        <MessageTemplatesList />
      ) : (
        <div className="shadow mb-6 mt-2 flex w-full overflow-y-auto rounded-lg border-none bg-layer-01 p-6">
          <NoCountriesPage />
        </div>
      )}
    </div>
  )
}
